import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

export interface TaskItem {
  _id: string;
  title: string;
  description?: string;
  status: string;
  priority: string;
  assigned_to?: string;
  assigned_name?: string;
  project_id?: string;
  project_name?: string;
  due_date?: string;
  created_at?: string;
}

export function useITTasks() {
  return useQuery<TaskItem[]>({
    queryKey: ['it-tasks'],
    queryFn: async () => {
      const res = await api.get('/api/tasks');
      return res.data?.tasks ?? res.data ?? [];
    },
    staleTime: 60_000,
  });
}
